import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }

    if (password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }

    setLoading(true);

    try {
      await register(email, password, name);
      toast.success("Compte créé avec succès !");
      navigate("/dashboard");
    } catch (error) {
      const message = error.response?.data?.detail || "Erreur lors de l'inscription";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary flex items-center justify-center pt-20 px-6" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="bg-white p-8 md:p-12 border border-border">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-3xl font-bold text-primary">
                ITERCATUS
              </span>
            </Link>
            <p className="text-xs text-muted-foreground italic mb-4">Le voyage intelligent</p>
            <h1 className="font-heading text-2xl font-bold text-primary">
              Créer un compte
            </h1>
            <p className="text-muted-foreground mt-2">
              Rejoignez notre communauté de voyageurs
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-primary mb-2">
                Nom complet
              </label>
              <Input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Jean Dupont"
                required
                className="h-12"
                data-testid="name-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primary mb-2">
                Email
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.com"
                required
                className="h-12"
                data-testid="email-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primary mb-2">
                Mot de passe
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-12"
                data-testid="password-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-primary mb-2">
                Confirmer le mot de passe
              </label>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-12"
                data-testid="confirm-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full btn-primary h-12"
              disabled={loading}
              data-testid="register-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Création...
                </>
              ) : (
                "Créer mon compte"
              )}
            </Button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-muted-foreground">
              Déjà inscrit ?{" "}
              <Link to="/connexion" className="text-accent hover:underline font-medium" data-testid="login-link">
                Se connecter
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
